import Const from "../const";

let string = {};
const skinType = Const.skinType.toUpperCase();

if (skinType === "GOGOIT") {
    string = {
        name: "고고잇",
        ncashSendByAdmin: "고고잇 전송",
        ncashSendByAdminCodeUtil: "고고잇입금",
        chatting: '고고잇톡',
    }
} else {
    string = {
        name: "냠냠박스",
        ncashSendByAdmin: '냠냠박스 전송',
        ncashSendByAdminCodeUtil: '냠냠박스입금',
        chatting: '냠냠톡',
    }
}

export default string;
